export default "__VITE_ASSET__8d64dc6a__"